import { createUseStyles } from 'react-jss';

export const useStackStyles = createUseStyles({
  container: {
    maxHeight: 400,
    overflow: 'auto',
  },
  code: {
    maxWidth: 0,
  },
});

export const useStyles = createUseStyles({
  dialog: {
    minWidth: 500,
    maxWidth: '90vw',
    whiteSpace: 'pre-line',
  },
  toast: {
    flex: 'auto',
  },
});
